/* ==========================================================================
   INCINOV JEWELLERY — Sepet betiği

   Sepet çekmecesi, sepete ekleme, adet değişimi ve satır silme.
   Hepsi Cart AJAX API + Section Rendering API ile, sayfa
   yenilenmeden.

   Betik yüklenmezse hiçbir şey kırılmaz: sepete ekle formu normal
   POST ile /cart'a gider, adet düğmeleri type="button" olduğu için
   formu tetiklemez ve klasik "Güncelle" düğmesi görünür kalır.

   Ayrı dosyada: global.js her sayfada yüklenir, bu yalnızca
   sepetle ilgili işler için.
   ========================================================================== */

(function () {
  'use strict';

  /* Çok dilli/çok para birimli mağazalarda kök yol '/' olmayabilir.
     Incinov tek dil tek para birimi ama kural aynı kalsın. */
  var KOK =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  /* Çekmece bölümünün adı — Section Rendering API bununla çağrılır.
     sections/sepet-cekmece.liquid dosya adıyla birebir aynı olmalı. */
  var CEKMECE_BOLUM = 'sepet-cekmece';

  /* Aynı anda iki istek gitmesin: hızlı tıklamada sepet karışır,
     sunucudan dönen iki yanıt birbirini eziyor */
  var istekSuruyor = false;

  var cekmece = null; /* PanelYap nesnesi, aşağıda kurulur */

  /* ------------------------------------------------------------------
     Yardımcılar
     ------------------------------------------------------------------ */

  /* Yükleme sırasında düğmeler kilitlenir. Yalnızca sepet alanları
     etkilenir — sayfanın geri kalanı kullanılabilir kalır. */
  function bekletmeyiAyarla(durum) {
    var alanlar = document.querySelectorAll(
      '[data-sepet-cekmece], [data-sepet-sayfasi]'
    );

    alanlar.forEach(function (alan) {
      if (durum) {
        alan.setAttribute('data-yukleniyor', '');
      } else {
        alan.removeAttribute('data-yukleniyor');
      }

      /* Düğmeler gerçekten disabled olur; yalnızca CSS ile
         soluklaştırmak tıklamayı engellemez */
      alan
        .querySelectorAll(
          '[data-adet-artir], [data-adet-azalt], [data-satir-sil], [data-adet-alan]'
        )
        .forEach(function (dugme) {
          dugme.disabled = !!durum;
        });
    });
  }

  /* Sunucudan gelen HTML içinden bir parçayı alıp yerine koyar */
  function parcayiDegistir(html, secici) {
    try {
      var yeni = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(secici);
      var mevcut = document.querySelector(secici);

      if (!yeni || !mevcut) return false;
      mevcut.innerHTML = yeni.innerHTML;
      return true;
    } catch (hata) {
      return false;
    }
  }

  /* Sepet sayacı — üst bilgide ve başka yerlerde birden çok
     olabilir, hepsi güncellenir */
  function sayaclariGuncelle(adet) {
    var sayaclar = document.querySelectorAll('[data-sepet-sayac]');

    sayaclar.forEach(function (sayac) {
      var onceki = sayac.textContent.trim();
      sayac.textContent = adet;
      /* Sayı değiştiyse kısa vurgu — sınıfı kaldırıp yeniden eklemek
         animasyonu baştan başlatır (offsetWidth akışı zorlar) */
      if (onceki !== String(adet) && adet > 0) {
        sayac.classList.remove('ust-bilgi__sayac--vurgu');
        void sayac.offsetWidth;
        sayac.classList.add('ust-bilgi__sayac--vurgu');
      }
      /* Boş sepette rozeti gizlemek CSS'in işi — sayı yerine
         işaret konur, böylece metin okunabilir kalır */
      if (adet > 0) {
        sayac.setAttribute('data-dolu', '');
        sayac.removeAttribute('hidden');
      } else {
        sayac.removeAttribute('data-dolu');
      }
    });
  }

  function hataYaz(alan, mesaj) {
    if (!alan) return;
    alan.textContent = mesaj || '';
    if (mesaj) {
      alan.removeAttribute('hidden');
    } else {
      alan.setAttribute('hidden', '');
    }
  }

  /* ------------------------------------------------------------------
     Çekmeceyi tazele — Section Rendering API

     /?sections=sepet-cekmece JSON döner: { "sepet-cekmece": "<html>" }
     Tek istekle bölümün taze hâli alınır, iç gövdesi yerine konur.

     🪤 Dönen HTML bölümün kendi sarmalayıcısını da içerir. İçeriği
     [data-sepet-cekmece-govde] ile sınırlamak gerekir; kök öğeyi
     komple değiştirmek çekmecenin açık/kapalı durumunu sıfırlar.
     ------------------------------------------------------------------ */
  function cekmeceyiTazele() {
    if (!document.querySelector('[data-sepet-cekmece-govde]')) {
      return Promise.resolve();
    }

    return fetch(KOK + '?sections=' + CEKMECE_BOLUM, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (yanit) {
        if (!yanit.ok) throw new Error('çekmece alınamadı');
        return yanit.json();
      })
      .then(function (bolumler) {
        var html = bolumler && bolumler[CEKMECE_BOLUM];
        if (!html) return;
        parcayiDegistir(html, '[data-sepet-cekmece-govde]');
      })
      .catch(function () {
        /* Tazeleme başarısızsa sepet içeriği eski kalır ama sayaç
           doğrudur. Sessizce yanlış göstermemek için bir sonraki
           açılışta sunucudan gelen hâl kullanılır. */
      });
  }

  /* Sepet durumunu çekip sayaçları günceller */
  function sayaciTazele() {
    return fetch(KOK + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (yanit) {
        if (!yanit.ok) throw new Error('sepet okunamadı');
        return yanit.json();
      })
      .then(function (sepet) {
        sayaclariGuncelle(sepet.item_count || 0);
        return sepet;
      })
      .catch(function () {
        return null;
      });
  }

  /* ------------------------------------------------------------------
     Sepet sayfasını tazele

     🪤 Eskiden adet değişince yalnız çekmece tazeleniyordu; sepet
     sayfasındaki ara toplam, kargo çubuğu ve özet eski kalıyordu.
     Sayfa bölümü kendi kimliğini data-sepet-sayfasi="{{ section.id }}"
     ile verir (şablondaki kimlik dinamik: template--…__ana).
     ------------------------------------------------------------------ */
  /* 🪤 Öneriler (sepet-onerileri) de tazelenir: sepetten ürün çıkınca
     "Setinizi tamamlayın" hâlâ çıkan ürünün setini gösteriyordu, eklenen
     ürün önerilerde kalıyordu. Tek istekte iki bölüm istenir. */
  function sayfayiTazele() {
    var sayfa = document.querySelector('[data-sepet-sayfasi]');
    var kimlik = sayfa && sayfa.getAttribute('data-sepet-sayfasi');
    if (!kimlik) return Promise.resolve();

    var oneriler = document.querySelector('[data-sepet-onerileri]');
    var oneriKimlik = oneriler && oneriler.getAttribute('data-sepet-onerileri');
    var istenen = oneriKimlik ? kimlik + ',' + oneriKimlik : kimlik;

    return fetch(KOK + 'cart?sections=' + encodeURIComponent(istenen), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (yanit) {
        if (!yanit.ok) throw new Error('sepet sayfası alınamadı');
        return yanit.json();
      })
      .then(function (bolumler) {
        var html = bolumler && bolumler[kimlik];
        if (html) parcayiDegistir(html, '[data-sepet-sayfasi]');
        var oneriHtml = oneriKimlik && bolumler[oneriKimlik];
        if (oneriHtml && parcayiDegistir(oneriHtml, '[data-sepet-onerileri]')) {
          /* Giriş hareketi sonradan eklenen kartta tetiklenmez — kartlar
             görünmez kalmasın (koleksiyon "daha fazla"daki kuralla aynı) */
          document.querySelectorAll('[data-sepet-onerileri] .giris').forEach(function (g) {
            g.classList.remove('giris');
          });
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function sepetiTazele() {
    return Promise.all([cekmeceyiTazele(), sayaciTazele(), sayfayiTazele()]);
  }

  /* ------------------------------------------------------------------
     Çekmece paneli

     global.js'teki panel çekirdeği kullanılır: odak tuzağı,
     kaydırma kilidi, Escape ve tetikleyiciye geri dönüş oradan
     gelir. Burada yeniden yazılsaydı iki panel aynı anda açıkken
     kaydırma kilidi erken çözülürdü.
     ------------------------------------------------------------------ */
  function cekmeceyiKur() {
    var panel = document.querySelector('[data-sepet-cekmece]');
    if (!panel || !window.Incinov || !window.Incinov.PanelYap) return;

    var dugmeler = Array.prototype.slice.call(
      document.querySelectorAll('[data-sepet-ac]')
    );

    panel.setAttribute('aria-hidden', 'true');
    dugmeler.forEach(function (dugme) {
      dugme.setAttribute('aria-expanded', 'false');
      if (panel.id) dugme.setAttribute('aria-controls', panel.id);
    });

    cekmece = window.Incinov.PanelYap({
      panel: panel,
      tetikleyiciler: dugmeler
    });
    window.Incinov.panelleriKaydet(cekmece);

    dugmeler.forEach(function (dugme) {
      dugme.addEventListener('click', function (olay) {
        /* Sepet ikonu genelde /cart bağlantısıdır — betik varsa
           çekmece açılır, yoksa bağlantı sepet sayfasına gider */
        olay.preventDefault();
        cekmece.degistir();
      });
    });

    /* Kapatma düğmesi ve arka plan örtüsü.
       Örtü tıklaması: hedef doğrudan örtünün kendisi olmalı —
       çekmece içindeki tıklamalar örtüye kadar kabarıp
       çekmeceyi kapatmasın. */
    panel.addEventListener('click', function (olay) {
      if (olay.target.closest('[data-sepet-kapat]')) {
        olay.preventDefault();
        cekmece.kapat();
        return;
      }

      if (olay.target.hasAttribute('data-sepet-ortu')) {
        cekmece.kapat();
      }
    });

    /* Betik hazır işareti: sepet ikonu ve "Güncelle" düğmesi
       bu işarete bakarak davranır */
    panel.setAttribute('data-cekmece-hazir', '');
  }

  function cekmeceyiAc() {
    if (cekmece) cekmece.ac();
  }

  /* ------------------------------------------------------------------
     Satır güncelleme — /cart/change.js

     Adet 0 verilirse Shopify satırı kendisi kaldırır; ayrı bir
     silme çağrısı gerekmez.
     ------------------------------------------------------------------ */
  function satiriGuncelle(anahtar, adet) {
    if (istekSuruyor || !anahtar) return Promise.resolve();

    istekSuruyor = true;
    bekletmeyiAyarla(true);

    return fetch(KOK + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: anahtar, quantity: adet })
    })
      .then(function (yanit) {
        if (!yanit.ok) throw new Error('sepet güncellenemedi');
        return yanit.json();
      })
      .then(function (sepet) {
        sayaclariGuncelle(sepet.item_count || 0);
        return Promise.all([cekmeceyiTazele(), sayfayiTazele()]);
      })
      .catch(function () {
        /* İstek düşerse sayfa yenilenir. Sessizce yanlış adet
           göstermek, bir yenilemeden daha kötüdür. */
        window.location.reload();
      })
      .then(function () {
        istekSuruyor = false;
        bekletmeyiAyarla(false);
      });
  }

  /* ------------------------------------------------------------------
     Sepete ekleme — /cart/add.js
     ------------------------------------------------------------------ */
  function sepeteEkle(form) {
    if (istekSuruyor) return;

    var hataAlani = form.querySelector('[data-sepet-hata]');
    var dugme = form.querySelector('[type="submit"]');

    hataYaz(hataAlani, '');

    istekSuruyor = true;
    if (dugme) {
      dugme.disabled = true;
      dugme.setAttribute('aria-busy', 'true');
    }

    var veri;
    try {
      veri = new FormData(form);
    } catch (hata) {
      /* FormData kurulamazsa kilidi bırak, klasik gönderime düş */
      istekSuruyor = false;
      if (dugme) {
        dugme.disabled = false;
        dugme.removeAttribute('aria-busy');
      }
      form.submit();
      return;
    }

    fetch(KOK + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: veri
    })
      .then(function (yanit) {
        return yanit.json().then(function (veri) {
          if (!yanit.ok) {
            /* Shopify hata gövdesinde description veya message
               döner — stokta yok, varyant seçilmemiş vb. */
            throw new Error(veri.description || veri.message || '');
          }
          return veri;
        });
      })
      .then(function () {
        return sepetiTazele();
      })
      .then(function () {
        cekmeceyiAc();
      })
      .catch(function (hata) {
        var mesaj = hata && hata.message ? hata.message : '';
        if (!mesaj) {
          mesaj =
            (hataAlani && hataAlani.getAttribute('data-varsayilan-mesaj')) ||
            'Ürün sepete eklenemedi. Lütfen tekrar deneyin.';
        }
        hataYaz(hataAlani, mesaj);
      })
      .then(function () {
        istekSuruyor = false;
        if (dugme) {
          dugme.disabled = false;
          dugme.removeAttribute('aria-busy');
        }
      });
  }

  /* ------------------------------------------------------------------
     Olay dinleyicileri

     Tek dinleyici belgeye bağlanır. Çekmece içeriği tazelendiğinde
     düğümler yenilenir — tek tek bağlanan dinleyiciler birinci
     güncellemeden sonra ölürdü.
     ------------------------------------------------------------------ */
  function olaylariKur() {
    document.addEventListener('click', function (olay) {
      /* ---- Satır silme ---- */
      var sil = olay.target.closest('[data-satir-sil]');
      if (sil) {
        olay.preventDefault();
        satiriGuncelle(sil.getAttribute('data-satir-anahtar'), 0);
        return;
      }

      /* ---- Adet azalt / artır ---- */
      var azalt = olay.target.closest('[data-adet-azalt]');
      var artir = olay.target.closest('[data-adet-artir]');
      if (!azalt && !artir) return;

      olay.preventDefault();

      var kutu = (azalt || artir).closest('[data-sepet-adet]');
      var alan = kutu
        ? kutu.querySelector('[data-adet-alan]')
        : null;
      if (!alan) return;

      var mevcut = parseInt(alan.value, 10);
      if (isNaN(mevcut)) mevcut = 0;

      var anahtar = alan.getAttribute('data-satir-anahtar');
      /* Ürün sayfasındaki adet kutusunda satır anahtarı yok: yalnız
         alan değişir, sepete istek gitmez; alt sınır 1 */
      var enAz = anahtar ? 0 : 1;

      var yeni = azalt ? mevcut - 1 : mevcut + 1;
      if (yeni < enAz) yeni = enAz;

      /* Alan hemen yazılır, istek arkada gider: tıklamaya anında
         tepki verilmiş olur */
      alan.value = yeni;
      if (anahtar) satiriGuncelle(anahtar, yeni);
    });

    /* ---- Adet alanına elle yazma ---- */
    document.addEventListener('change', function (olay) {
      var alan = olay.target.closest('[data-adet-alan]');
      if (!alan) return;

      var anahtar = alan.getAttribute('data-satir-anahtar');
      var enAz = anahtar ? 0 : 1;
      var adet = parseInt(alan.value, 10);
      if (isNaN(adet) || adet < enAz) adet = enAz;
      alan.value = adet;

      if (anahtar) satiriGuncelle(anahtar, adet);
    });

    /* ---- Sepete ekleme formu ----
       🪤 data-sepet-form bazen formun kendisinde (ikili kombin,
       çekmece önerileri), bazen onu saran div'de (ürün sayfası —
       {% form %} etiketine tireli öznitelik yazılamıyor). Eskiden
       closest() div'i buluyordu, new FormData(div) TypeError atıyor,
       preventDefault çoktan çalıştığı için ürün sepete hiç
       eklenmiyor ve istekSuruyor kilidi açık kalıyordu. Artık her
       zaman gönderilen <form> öğesi kullanılır. */
    document.addEventListener('submit', function (olay) {
      var form = olay.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.hasAttribute('data-sepet-form') && !form.closest('[data-sepet-form]')) return;

      /* Çekmece yoksa klasik gönderim daha doğru: kişi ürünü
         eklediğini görmeli, sessizce hiçbir şey olmamalı değil */
      if (!cekmece) return;

      olay.preventDefault();
      sepeteEkle(form);
    });
  }

  /* ------------------------------------------------------------------
     Başlangıç
     ------------------------------------------------------------------ */
  function kur() {
    try {
      cekmeceyiKur();
      olaylariKur();
    } catch (hata) {
      if (window.console && console.warn) {
        console.warn('Incinov: sepet betiği kurulamadı', hata);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }

  /* Dışa açılan yüzey — başka bölümler sepeti tazeleyebilsin */
  window.IncinovSepet = {
    ac: cekmeceyiAc,
    kapat: function () {
      if (cekmece) cekmece.kapat();
    },
    tazele: sepetiTazele
  };
})();
